"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Views = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _appLayout = _interopRequireDefault(require("../layouts/app-layout"));

var _authLayout = _interopRequireDefault(require("../layouts/auth-layout"));

var _lang = _interopRequireDefault(require("../lang"));

var _reactIntl = require("react-intl");

var _antd = require("antd");

var _AppConfig = require("../configs/AppConfig");

function RouteInterceptor(_ref) {
  var children = _ref.children,
      isAuthenticated = _ref.isAuthenticated,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["children", "isAuthenticated"]);
  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, Object.assign({}, rest, {
    render: function render(_ref2) {
      var location = _ref2.location;
      return isAuthenticated ? children : /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: _AppConfig.AUTH_PREFIX_PATH,
          state: {
            from: location
          }
        }
      });
    }
  }));
}

var Views = function Views(props) {
  var locale = props.locale,
      location = props.location;
  var currentAppLocale = _lang.default[locale];
  var cl = localStorage.getItem("CL");
  var token = localStorage.getItem("token");
  return /*#__PURE__*/_react.default.createElement(_reactIntl.IntlProvider, {
    locale: currentAppLocale.locale,
    messages: currentAppLocale.messages
  }, /*#__PURE__*/_react.default.createElement(_antd.ConfigProvider, {
    locale: currentAppLocale.antd
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: "/clPortal"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: _AppConfig.AUTH_PREFIX_PATH
  })), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: _AppConfig.AUTH_PREFIX_PATH
  }, /*#__PURE__*/_react.default.createElement(_authLayout.default, null)), cl !== '' && token ? /*#__PURE__*/_react.default.createElement(RouteInterceptor, {
    path: _AppConfig.APP_PREFIX_PATH,
    isAuthenticated: "7"
  }, /*#__PURE__*/_react.default.createElement(_appLayout.default, {
    location: location
  })) : null)));
};

exports.Views = Views;

var mapStateToProps = function mapStateToProps(_ref3) {
  var theme = _ref3.theme,
      auth = _ref3.auth;
  var locale = theme.locale;
  var token = auth.token;
  return {
    locale: locale,
    token: token
  };
};

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)(mapStateToProps)(Views));

exports.default = _default;